import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { Page, Roles } from '@/store/profile/types';

const namespace = 'profile';

@Component
export default class UserMixin extends Vue {
  @Action('logout', { namespace: 'profile' }) logoutAction: any;

  @Getter('getSession', { namespace }) session!: Record<string, any>;

  @Getter('getPages', { namespace }) _userPages!: Array<any>;

  get userPages(): Array<any> {
    return this._userPages.map((v: Page) => {
      v.name = this.$t(v.name).toString();
      return v;
    });
  }

  get currentPage() {
    const route = this.$route;
    return this.userPages.find((v) => v.to?.name === route.name && v.to?.params?.entityName === route.params?.entityName);
  }

  get userFullName(): string {
    return this.session?.user_pimcore?.full_name || 'Имя не указано';
  }

  get isExternal(): boolean {
    return this.session?.user_type === 'external';
  }

  get supplierData() {
    return this.session?.user_supplier || {};
  }

  get pimcoreUser() {
    return this.session?.user_pimcore || null;
  }

  get userPlatforms(): any[] {
    const platforms = this.pimcoreUser?.PlantsHR;
    return platforms === null || typeof platforms === 'undefined' ? [] : platforms;
  }

  get userPlatformIds(): number[] {
    return this.userPlatforms.map((platform: any) => platform?.id).filter((platformId: number | null) => platformId !== null);
  }

  get userRole(): Record<any, any> | null {
    return this.pimcoreUser?.role || null;
  }

  get isGuest(): boolean {
    return this.userRole?.role_type === Roles.GUEST;
  }

  get isSupplier(): boolean {
    return this.userRole?.role_type === Roles.SUPPLIER;
  }

  get isSupervisor(): boolean {
    return this.userRole?.role_type === Roles.SUPERVISOR;
  }

  get isCoordinator(): boolean {
    return this.userRole?.role_type === Roles.COORDINATOR;
  }

  get isHR(): boolean {
    return this.userRole?.role_type === Roles.HR;
  }

  get isControlling(): boolean {
    return this.userRole?.role_type === Roles.CONTROLLING;
  }

  get isPretensionController(): boolean {
    return this.isControlling;
  }

  get isAccountant(): boolean {
    return this.userRole?.role_type === Roles.ACCOUNTANT;
  }

  get isSigner(): boolean {
    return this.userRole?.role_type === Roles.SIGNER;
  }

  async logout() {
    await this.logoutAction();
    this.$router.push({ name: 'Login' });
    return true;
  }
}
